export default "__VITE_ASSET__DNsWpc$E__"